import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { mapGetters } from 'vuex';
export default {
  name: 'ProductOpenGraph',
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: true
    },
    price: {
      type: Number,
      default: 0
    },
    url: {
      type: String,
      required: true
    },
    isMarketplace: {
      type: Boolean,
      default: false
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    seoDescription() {
      if (!this.isMarketplace) {
        return this.description;
      }

      return "".concat(this.title, " en vente chez Maisons du Monde. D\xE9couvrez toutes les informations sur le produit et nos offres associ\xE9es.");
    }

  }),

  head() {
    var meta = [{
      property: 'og:title',
      content: "".concat(this.title, " | Maisons du Monde")
    }, {
      property: 'og:description',
      content: this.seoDescription
    }, {
      property: 'og:url',
      content: this.url
    }, {
      property: 'og:type',
      content: 'product'
    }, {
      property: 'og:image',
      content: this.image
    }, {
      property: 'og:locale',
      content: this.locale.iso
    }, {
      property: 'product:price:currency',
      content: this.locale.currency
    }];

    if (this.price) {
      meta.push({
        property: 'product:price:amount',
        content: this.price
      });
    }

    return {
      meta
    };
  },

  render: h => h(null)
};